@import "~@uipath/apollo-core/src/scss/base-host.scss";

:host {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .time-left {
        font-size: $font-s-size;
        line-height: $font-m-line-height;
        color: var(--color-foreground);
        font-family: $font-normal;
        font-style: normal;
        margin-top: 1px;
        margin-right: 9px;
    }
    
    .buy-now-button {
        justify-content: center;
        margin-left: 9px;
    }
  }
